import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { MemberProvider } from "@/context/MemberContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import RegionGate from "@/components/RegionGate";
import SiteVisitTracker from "@/components/SiteVisitTracker";

import Home from "@/pages/Home";
import Books from "@/pages/Books";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Contact from "@/pages/Contact";
import Healing from "@/pages/Healing";
import HealingEntry from "@/pages/HealingEntry";
import VerifyMember from "@/pages/member/VerifyMember";

import Login from "@/pages/admin/Login";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import Overview from "@/pages/admin/Overview";
import BooksAdmin from "@/pages/admin/BooksAdmin";
import PostsAdmin from "@/pages/admin/PostsAdmin";
import MessagesAdmin from "@/pages/admin/MessagesAdmin";
import MembersAdmin from "@/pages/admin/MembersAdmin";
import HealingAdmin from "@/pages/admin/HealingAdmin";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <MemberProvider>
        <BrowserRouter>
          <GoogleAnalytics />
          <SiteVisitTracker />
          <RegionGate>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/books" element={<Books />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalPost />} />
            <Route path="/healing" element={<Healing />} />
            <Route path="/healing/:slug" element={<HealingEntry />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/member/verify" element={<VerifyMember />} />

            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password/:token" element={<ResetPassword />} />
            <Route path="/admin" element={<ProtectedRoute><Overview /></ProtectedRoute>} />
            <Route path="/admin/books" element={<ProtectedRoute><BooksAdmin /></ProtectedRoute>} />
            <Route path="/admin/posts" element={<ProtectedRoute><PostsAdmin /></ProtectedRoute>} />
            <Route path="/admin/healing" element={<ProtectedRoute><HealingAdmin /></ProtectedRoute>} />
            <Route path="/admin/members" element={<ProtectedRoute><MembersAdmin /></ProtectedRoute>} />
            <Route path="/admin/messages" element={<ProtectedRoute><MessagesAdmin /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          </Routes>
          </RegionGate>
        </BrowserRouter>
      </MemberProvider>
    </AuthProvider>
  );
}

export default App;
